export const REDIRECT_KEY = 'RedirectUrl';
export const LARGE_SCREEN_MINIMUM_WIDTH = 1024;